import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { QradarEDRState, QradarEDRDispatch } from './store';

export const useQradarEDRDispatch = (): QradarEDRDispatch =>
  useDispatch<QradarEDRDispatch>();
export const useQradarEDRSelector: TypedUseSelectorHook<QradarEDRState> =
  useSelector;
